/* !
 * jQuery products v1.0.0
 * Copyright 2018, Connecty Inc.
 */
(function($, IBANEZ, cssua){
	const a = 'is-active';
	const urlRegion = IBANEZ.va.pathname.split('/')[1];
	const map = IBANEZ.va.pathname.split('/')[3];
	const thisCat = IBANEZ.va.pathname.split('/')[4];
	let sort = IBANEZ.va.pathname.split('/')[6]; // searchで使用
	if(!sort) { sort = ''; }
	const thisSearch = location.search;
	let thisParam = [];
	if(thisSearch) { thisParam = thisSearch.replace(/\?/, '').split('&'); }

	// JSON
	const getJSONProdItem = (_key) => {
		return $.getJSON(`/${urlRegion}/ajax/products/${_key}.json`);
	};
	const getJSONModelFeatures = (_seriesID) => {
		// console.log(`/${urlRegion}/ajax/news_blocks/${_seriesID}.json`);
		return $.getJSON(`/${urlRegion}/ajax/news_blocks/${_seriesID}.json`);
	};
	const getJSONModelSeriesProd = (_seriesID) => {
		return $.getJSON(`/${urlRegion}/ajax/series_products/${_seriesID}.json`);
	};
	const getJSONSearchForm = (_target, _subCat) => {
		if(_subCat) {
			return $.getJSON(`/${urlRegion}/ajax/${_target}/accessories_${_subCat}.json`);
		} else {
			return $.getJSON(`/${urlRegion}/ajax/${_target}/${thisCat}.json`);
		}
	};
	const getJSONsignatureModel = (_cat, _key) => {
		return $.getJSON(`/${urlRegion}/ajax/category_model/${_cat}/${_key}.json`);
	};

	// ＜商品検索＞
	const setParam = () => {
		let newParam = '?';
		for(let i=0; i<thisParam.length; i++) {
			if(thisParam[i].indexOf('result_skip') === -1) {
				newParam += `${thisParam[i]}&`;
			}
		}
		return newParam.slice(0, -1);
	};
	const changeParam = (_name, _val) => {
		let setFlg = false;
		for(let i = 0; i < thisParam.length; i++) {
			if(thisParam[i].indexOf(_name) !== -1) {
				thisParam[i] = `${_name}=${_val}`;
				setFlg = true;
			}
		}
		if(!setFlg) {
			thisParam.push(`${_name}=${_val}`);
		}
	};
	const addParam = (_name, _val) => {
		thisParam.push(`${_name}=${_val}`);
	};
	const removeParam = (_name, _val) => {
		for(let i = 0; i < thisParam.length; i++) {
			if(thisParam[i] === `${_name}=${_val}`) {
				thisParam.splice(i, 1);
			}
		}
	};
	const setTagLabel = () => {
		let labelsHTML = '';
		if(thisParam.length) {
			for(let i = 0; i < thisParam.length; i++) {
				let name = thisParam[i].split('=')[0];
				let val = thisParam[i].split('=')[1].replace(/%20/g, ' ');
				let label;
				if(thisParam[i].indexOf('cf_search_product_code') !== -1) {
					label = val;
				} else if(thisParam[i].indexOf('cf_search_color') !== -1) {
					label = $(`input[name="${name}"][value="${val}"]`).prev('span').text();
				} else if($(`input[name="${name}"][value="${val}"]`).length) {
					label = $(`input[name="${name}"][value="${val}"]`).next('span').text();
				}
				if(label && val) {
					labelsHTML +=
					`<li class="products-categorList-result-labels-item" data-name="${name}" data-value="${val}">
					<span class="products-categorList-result-labels-item-text">${label}<i class="icon icon-cloase js-deleteLabel" tabindex="0"></i>
					</span></li>`;
				}
			}
		}
		if(labelsHTML) {
			$('.js-search-labels').append(labelsHTML);
		} else {
			$('.products-categorList-result-head').remove();
		}

		// タグラベル削除ボタン押下時
		const deleteLabelClick = (e) => {
			let name = $(e.currentTarget).parents('.products-categorList-result-labels-item').attr('data-name');
			let val = $(e.currentTarget).parents('.products-categorList-result-labels-item').attr('data-value').replace(/ /g, '%20');
			let newParam = thisParam.filter(n => n !== `${name}=${val}`);
			thisParam = newParam;
			location.href = `/${urlRegion}/products/search/${thisCat}/list/${sort}${setParam()}`;
		};
		$('.js-deleteLabel').on('click', (e) => { deleteLabelClick(e); });
		$('.js-deleteLabel').keydown(function (e) {
			if (e.key === 'Enter') { deleteLabelClick(e); }
		});
	};
	const setCheckbox = () => {
		// MODEL/CATEGORY/SERIES json
		if($('.js-checkbox')[0]) {
			let p = new Promise((resolve) => {
				let appendCnt = 0;
				$('.js-checkbox').each((idx, ele) => {
					const target = $(ele).attr('data-target');
					let subCat = '';
					if($(ele).attr('data-subcat')) {
						subCat = $(ele).attr('data-subcat');
					}
					getJSONSearchForm(target, subCat).then((data) => {
						let dataArr, searchName;
						if(target === 'model') {
							dataArr = data.rt_bn_product_model;
							searchName = 'cf_search_model_id';
						} else if(target === 'series') {
							dataArr = data.rt_bn_product_series;
							searchName = 'cf_search_series';
						} else if(target === 'category') { // ELECTRONICSのみ
							dataArr = data.rt_bn_product_category;
							searchName = 'cf_search_category_id';
						}
						if(dataArr.length) {
							let appendHTML = '';
							for (let i=0; i<dataArr.length; i++) {
								let thisName = '';
								if(target === 'model') {
									switch(urlRegion) {
									case'jp': thisName = dataArr[i].cf_pm_name_jp; break;
									case'cn': thisName = dataArr[i].cf_pm_name_cn; break;
									case'usa': thisName = dataArr[i].cf_pm_name_us; break;
									case'na': thisName = dataArr[i].cf_pm_name_na; break;
									case'eu': thisName = dataArr[i].cf_pm_name_eu; break;
									case'asia': thisName = dataArr[i].cf_pm_name_as; break;
									default: thisName = dataArr[i].cf_pm_id;
									}
									if(!thisName) { thisName = dataArr[i].cf_pm_no; }
								} else if(target === 'series') {
									switch(urlRegion) {
									case'jp': thisName = dataArr[i].cf_ps_name_jp; break;
									case'cn': thisName = dataArr[i].cf_ps_name_cn; break;
									case'usa': thisName = dataArr[i].cf_ps_name_us; break;
									case'na': thisName = dataArr[i].cf_ps_name_na; break;
									case'eu': thisName = dataArr[i].cf_ps_name_eu; break;
									case'asia': thisName = dataArr[i].cf_ps_name_as; break;
									default: thisName = dataArr[i].cf_ps_id;
									}
									if(!thisName) { thisName = dataArr[i].cf_ps_id; }
								} else if(target === 'category') {
									switch(urlRegion) {
									case'jp': thisName = dataArr[i].cf_pc_name_jp; break;
									case'cn': thisName = dataArr[i].cf_pc_name_cn; break;
									case'usa': thisName = dataArr[i].cf_pc_name_us; break;
									case'na': thisName = dataArr[i].cf_pc_name_na; break;
									case'eu': thisName = dataArr[i].cf_pc_name_eu; break;
									case'asia': thisName = dataArr[i].cf_pc_name_as; break;
									default: thisName = dataArr[i].cf_pc_name_jp;
									}
								}
								appendHTML +=
									`<label><input type="checkbox" name="${searchName}" value="${dataArr[i]._key}" title="${thisName}">` +
									`<span class="products-categorList-search-body-checkbox-text">${thisName}</span></label>`;
							}
							$(ele).prepend(appendHTML);
							appendCnt++;
							if(appendCnt === $('.js-checkbox').length) {
								return resolve();
							}
						}
					});
				});
			});
			Promise.all([p]).then(() => {
				// 現在検索されている項目を反映
				$('.js-checkbox').each((idx, ele) => {
					$(ele).find('input[type="checkbox"]').each((idx2, ele2) => {
						if(thisSearch.indexOf(`${$(ele2).attr('name')}=${$(ele2).attr('value')}`) !== -1) {
							$(ele2).prop('checked', 'checked');
						}
					});
				});
				// 全チェックボックス押下時の処理
				$('input[type="checkbox"]').each((idx, ele) => {
					$(ele).change((e) => {
						if($(e.currentTarget).prop('checked')) {
							addParam($(e.currentTarget).attr('name'), $(e.currentTarget).val());
							location.href = `/${urlRegion}/products/search/${thisCat}/list/${sort}${setParam()}`;
						} else {
							removeParam($(e.currentTarget).attr('name'), $(e.currentTarget).val().replace(/ /g, '%20'));
							location.href = `/${urlRegion}/products/search/${thisCat}/list/${sort}${setParam()}`;
						}
					});
				});
				// 検索結果：タグラベル
				setTagLabel();
			});
		}
	};
	const setSort = () => {
		// select選択状態
		$('.js-select-sort').val(sort.replace(/\.html/, ''));
		// select切替
		$('.js-select-sort').change((e) => {
			if($(e.currentTarget).val() !== '') {
				location.href = `/${urlRegion}/products/search/${thisCat}/list/${$(e.currentTarget).val()}.html${setParam()}`;
			} else {
				location.href = `/${urlRegion}/products/search/${thisCat}/list/${setParam()}`;
			}
		});
	};
	const colorChips = () => {
		$('.products-categorList-search-body-color-block-li').each((idx, ele) => {
			$(ele).hover(() => {
				$(ele).find('.products-categorList-search-body-color-title').addClass(a);
			}, () => {
				$(ele).find('.products-categorList-search-body-color-title').removeClass(a);
			});
		});
	};
	if(map === 'search') {
		// カテゴリclassを付与
		$('.js-categorList-result').addClass(thisCat);
		// SELECT CATEGORY(BIG CATEGORY)
		const $selectCat = $('.js-select-category');
		$selectCat.val(thisCat);
		$selectCat.change((e) => {
			location.href = `/${urlRegion}/products/search/${$(e.currentTarget).val()}/list/`;
		});
		// checkbox
		setCheckbox();
		// MODEL NUMBER
		$('.js-model-number').change((e) => {
			changeParam('cf_search_product_code', $(e.currentTarget).val());
			location.href = `/${urlRegion}/products/search/${thisCat}/list/${sort}${setParam()}`;
		});
		// カラーチップタイトル ホバー表示
		colorChips();
		// ソート順
		setSort();
		// ALL CLEAR
		$('.js-allClear').on('click', () => { location.href = `/${urlRegion}/products/search/${thisCat}/list/${sort}`; });
		$('.js-allClear').keydown(function (e) {
			if (e.key === 'Enter') { location.href = `/${urlRegion}/products/search/${thisCat}/list/${sort}`; }
		});
	}

	// ＜CATEGORY/MODEL＞ findLINK
	const $findLink = $('.js-findLink');
	if($findLink.length) {
		if(map === 'model') {
			const prodCat = $('.mod-topicPath-li').eq(2).find('a').attr('href').split('/')[4];
			$findLink.attr('href', `/${urlRegion}/products/search/${prodCat}/list/`);
		} else if(map === 'category') {
			const prodCat = IBANEZ.va.pathname.split('/')[4];
			$findLink.attr('href', `/${urlRegion}/products/search/${prodCat}/list/`);
		}
	}

	// ＜CATEGORY＞ アーティストブロック内のモデル名カテゴリチェック
	const checkModelCategory = () => {
		$('.rt_bn_artist').each((idx, ele) => {
			$(ele).find('.cf_a_signature_models').each((idx2, ele2) => {
				getJSONsignatureModel(thisCat, $(ele2).find('.rt_cf_a_signature_models_cf_pm_name').attr('data-key')).then((data) => {
					if(!data.rt_bn_product_model.length) {
						$(ele2).remove();
					}
				});
			});
		});
	};
	if(map === 'category') {
		// FEATURE PRODUCTS/SIGNATURE MODELSが空なら枠削除
		if($('.products-features').find('.rt_bn_feature_products_list').length === 0) {
			$('.products-features').remove();
		}
		if($('.products-signature').find('.rt_bn_artist').length === 0) {
			$('.products-signature').remove();
		}

		checkModelCategory();
	}

	// ＜MODEL＞ Features
	const setModelFeatures = (_seriesID, _$this) => {
		getJSONModelFeatures(_seriesID).then((data) => {
			if(data.rt_bn_blocks_list.length) {
				let featuresItemHTML = '';
				for(let i=0; i<data.rt_bn_blocks_list.length; i++) {
					// タイトルとテキストのtext-align
					let taTitle = 'ta_left';
					if(data.rt_bn_blocks_list[i].cf_b_img_types[0].cf_it_title_align === 2) {
						taTitle = 'ta_center';
					} else if(data.rt_bn_blocks_list[i].cf_b_img_types[0].cf_it_title_align === 3) {
						taTitle = 'ta_right';
					}
					let taText = 'ta_left';
					if(data.rt_bn_blocks_list[i].cf_b_img_types[0].cf_it_text_align === 2) {
						taText = 'ta_center';
					} else if(data.rt_bn_blocks_list[i].cf_b_img_types[0].cf_it_text_align === 3) {
						taText = 'ta_right';
					}
					featuresItemHTML +=
					`<li class="pure-g pure-g-flow_reverse space-u-30 mb30">
					<div class="pure-u-2-5 pure-u-md-1 space-u-30-child">
					<img src="./news_file/file/${data.rt_bn_blocks_list[i].cf_b_img_types[0].cf_it_image_file}" class="width-u-100"
					alt="${data.rt_bn_blocks_list[i].cf_b_img_types[0].cf_it_image_alt}"></div>
					<div class="pure-u-3-5 pure-u-md-1 space-u-30-child">
					<p class="fs_large_s fw_bold ${taTitle}">${data.rt_bn_blocks_list[i].cf_b_img_types[0].cf_it_title}</p>
					<p class="mod-spacer fs_middle_s ${taText}">${data.rt_bn_blocks_list[i].cf_b_img_types[0].cf_it_text}</p>
					</div></li>`;
				}
				_$this.find('.products-model-series-features-list').append(featuresItemHTML);
			} else {
				_$this.find('.products-model-series-features').remove();
			}
		});
	};
	// ＜MODEL＞ lineup
	const setModelSeriesProd = (_seriesID, _$this) => {
		getJSONModelSeriesProd(_seriesID).then((data) => {
			if(data.rt_bn_product.length) {
				let lineupItemHTML = '';
				for (let i = 0; i < data.rt_bn_product.length; i++) {
					lineupItemHTML +=
					'<li class="pure-u-1-3 pure-u-md-1-2 products-lineup-item mb20">' +
					`<a href="/${urlRegion}/products/detail/${data.rt_bn_product[i]._key}.html" class="mod-a">` +
					`<figure><img src="/common/product_artist_file/file/${data.rt_bn_product[i].cf_cm_region_thumb_img}?_size=1"` +
					` alt="${data.rt_bn_product[i].cf_cm_region_img_alt_1}" class="width-u-100"></figure>` +
					`<p class="mt20"><span class="color_black fw_bold va_middle pr10">${data.rt_bn_product[i].cf_cm_product_code}</span>`;
					if (data.rt_bn_product[i].cf_cm_series_id.cf_ps_logo_img) {
						lineupItemHTML +=
						'<span class="va_middle">' +
						`<img src="/common/product_artist_file/file/${data.rt_bn_product[i].cf_cm_series_id.cf_ps_logo_img}" class="width-u-20 va_middle"` +
						` alt="${data.rt_bn_product[i].cf_cm_series_id.cf_ps_logo_alt}"></span>`;
					}
					lineupItemHTML += '</p></a></li>';
				}
				_$this.find('.products-model-series-lineup-list').append(lineupItemHTML);
			} else {
				_$this.find('.products-model-series-lineup').remove();
			}
		});
	};
	if(map === 'model') {
		$('.products-model-series').each((idx, ele) => {
			const seriesID = $(ele).find('.rt_cf_ps_id').attr('id');
			setModelFeatures(seriesID, $(ele));
			setModelSeriesProd(seriesID, $(ele));
		});
		// シリーズアンカースクロール後にフォーカスを移動
		$('.rt_cf_ps_href').each((idx, ele) => {
			$(ele).keydown((e) => {
				if (e.key === 'Enter') {
					$($(ele).attr('href')).focus();
					var pos = $($(ele).attr('href')).offset().top;
					if (IBANEZ.va.window.width < IBANEZ.va.device.sp) {
						pos -= 60;
					} else {
						pos -= 104;
					}
					$('html,body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
				}
			})
		});
	}

	// ＜商品詳細＞メイン画像拡大鏡
	const detailModal = () => {
		if(!cssua.ua.mobile && $('.products-detail-main-modal').length &&
			$('.mod-topicPath-li').eq(2).find('a').attr('href').indexOf('electronics') === -1 &&
			$('.mod-topicPath-li').eq(2).find('a').attr('href').indexOf('accessories') === -1) {
			const $modal_content = $('.products-detail-main-modal');
			const $modal_content_area = $('.products-detail-main-modal-area');
			const $modal_content_img = $('.products-detail-main-modal-img');

			$modal_content.hover((e) => {
				const $this = $(e.currentTarget);
				const modal_content_img_width = e.currentTarget.childNodes[3].naturalWidth;
				const thisImg = $this.find($modal_content_img).attr('src');

				$this.addClass(a);
				$this.find($modal_content_area).css({
					'background-image': `url(${thisImg})`,
					'background-size': `${modal_content_img_width} auto`,
				});

				$this.mousemove((e2) => {
					const $this2 = $(e2.currentTarget);
					const content_height = $this2.outerHeight();
					const content_width = $this2.outerWidth();
					const cursorY = e2.offsetY; // Y座標
					const cursorX = e2.offsetX; // X座標
					const cursorY_per = cursorY / content_height * 100;
					const cursorX_per = cursorX / content_width * 100;

					$this2.find($modal_content_area).css({
						'background-position' : `${cursorX_per}% ${cursorY_per}%`
					});
				});
			}, (e) => {
				$(e.currentTarget).removeClass(a);
				$(e.currentTarget).find($modal_content_area).css('background-image', 'none');
			});
		}
	};
	// ＜商品詳細＞ サブ画像・カラーチップ・カラーテキスト切り替え
	const changeProdSubImg = () => {
		const $listWrap = $('.products-detail-main-listWrap');
		if(!$listWrap.find('.products-detail-main-list').length) {
			$listWrap.addClass('is-noImg');
		}
		// 画像のsrcがなかったら非表示（要素は削除しない）
		$('.js-prodDetail-subImg').each((idx, ele) => {
			if(!$(ele).attr('src')) {
				$(ele).parents('.products-detail-main-list').addClass('is-imgUnknown');
			}
		});

		const $tabParent = $('.js-prodDetail-tab-parent');
		const $regionColor = $('.js-region-color');
		$tabParent.eq(0).addClass(a);
		$regionColor.eq(0).addClass(a);
		$('.products-detail-main-item').eq(0).addClass(a);
		$('.products-detail-main-list[class$="1_is"]').each((idx, ele) => { $(ele).addClass(a); });

		$tabParent.each((idx, ele) => {
			$(ele).on('click', (e) => {
				let index = $tabParent.index($(ele));
				$tabParent.removeClass(a);
				$regionColor.removeClass(a);
				$('.products-detail-main-item').removeClass(a);
				$('.products-detail-main-list').removeClass(a);

				$(e.currentTarget).addClass(a);
				$regionColor.eq(index).addClass(a);
				$('.products-detail-main-item').eq(index).addClass(a);
				$(`.products-detail-main-list[class$="${index + 1}_is"]`).each((idx, ele) => { $(ele).addClass(a); });
			});
		});

		// カラーバリエーション部分
		for(let i=0; i<$regionColor.length; i++) {
			$('.js-region-color-name').eq(i).text($regionColor.eq(i).text());
		}
	};
	// ＜商品詳細＞ 関連商品
	const setRelatedProd = () => {
		let relatedList = [];
		const $prodKeys = $('.rt_cf_p_cm_related_products');
		if($prodKeys[0]) {
			let p = new Promise((resolve) => {
				let count = 0;
				$prodKeys.each((idx, ele) => {
					const prodKey = $(ele).find('.rt_cf_p_cm_related_products_id').text();
					getJSONProdItem(prodKey).then((data) => {
						if(data.rt_bn_product.length) {
							relatedList[idx] = {
								img: data.rt_bn_product[0].cf_cm_region_thumb_img,
								alt: data.rt_bn_product[0].cf_cm_region_img_alt_1,
								code: data.rt_bn_product[0].cf_cm_product_code,
								key: prodKey
							};
							++count;
							if(count === $prodKeys.length) {
								return resolve(relatedList);
							}
						} else {
							relatedList[idx] = 'nodata';
							++count;
							if(count === $prodKeys.length) {
								return resolve(relatedList);
							}
						}
					});
				});
			});
			Promise.all([p]).then(() => {
				let relatedHTML = '';
				for(let i=0; i<relatedList.length; i++) {
					if(relatedList[i] !== 'nodata') {
						relatedHTML +=
						'<li class="products-related-item">' +
						`<a href="/${urlRegion}/products/detail/${relatedList[i].key}.html" class="mod-a">` +
						`<figure><img src="/common/product_artist_file/file/${relatedList[i].img}?_size=1" ` +
						`alt="${relatedList[i].alt}" class="width-u-100"></figure>` +
						`<p class="color_black fw_bold pl10">${relatedList[i].code}</p></a></li>`;
					}
				}
				$('.products-related-slide').append(relatedHTML);
				$('.products-related-slide').slick({
					autoplay: true,
					slidesToShow: 5,
					slidesToScroll: 1,
					prevArrow: '<i class="icon icon-arrow_left mod-slide-arrow mod-slide-arrow-big mod-slide-arrow_left mod-slide-arrow-big_left"></i>',
					nextArrow: '<i class="icon icon-arrow_right mod-slide-arrow mod-slide-arrow-big mod-slide-arrow_right mod-slide-arrow-big_right"></i>',
					loop: true,
					infinite: true,
					responsive: [{
						breakpoint: 768,
						settings: {
							centerMode: true,
							centerPadding: '20%',
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}]
				});
			});
		}
	};
	if(map === 'detail') {
		detailModal();

		changeProdSubImg();
		if($('#products_detail_related-products')[0]) {
			setRelatedProd();
		}

		// SPECブロックにデータがなければブロック削除
		$('.js-spec-block').each((idx, ele) => {
			let thisTblFlg = false;
			$(ele).find('.products-spec-table').each((idx2, ele2) => {
				if($(ele2).find('.products-spec-table-li').eq(1).find('span')[0]) {
					thisTblFlg = true;
				}
			});
			if(!thisTblFlg) {
				$(ele).remove();
			}
		});
		// SPEC > OTHERS データがなければブロック削除
		if(!$('.js-spec-others .products-spec-table')[0]) {
			$('.js-spec-others').remove();
		} else {
			// 出力テキストをHTML化
			$('.rt_cf_p_data_others_str').each((idx, ele) => {
				$(ele).html($(ele).text());
			});
			$('.rt_cf_p_amp_others_str').each((idx, ele) => {
				$(ele).html($(ele).text());
			});
		}
		// Featuresセクション
		if(!$('#products_detail_features .rt_bn_block_list')[0]) {
			$('#products_detail_features').remove();
			$('.products-detail-nav-content-in[data-target="features"]').remove();
		}
		// OTHERSセクション
		if(!$('#products_detail_others .rt_bn_others_list')[0]) {
			$('#products_detail_others').remove();
			$('.products-detail-nav-content-in[data-target="others"]').remove();
		}

		// ACOUTRICのみ、NECK DIMENSIONS＞Scaleのスケールインチ「0」の場合 /0" を削除
		if($('.mod-topicPath-li').eq(2).find('a').attr('href').indexOf('acoustic_guitars') !== -1) {
			if(!$('.rt_cf_p_data_scale_inch')[0]) {
				$('.rt_cf_p_data_scale_mm').parent('.products-spec-table-li').text(`${$('.rt_cf_p_data_scale_mm').text()}`);
			}
		}
	}

	// YOUR RECENTLY VIEWED PRODUCTS ※region別に保存・取得
	// ＜商品詳細＞ localStorage登録 {'urlRegion/_key', datetime}
	const setRecentlyItemStorage = (_key) => {
		const viewDatetime = new Date();
		let year = viewDatetime.getFullYear();
		let month = viewDatetime.getMonth()+1; month = ('0' + month).slice(-2);
		let date = viewDatetime.getDate(); date = ('0' + date).slice(-2);
		let hour = viewDatetime.getHours(); hour = ('0' + hour).slice(-2);
		let minute = viewDatetime.getMinutes(); minute = ('0' + minute).slice(-2);
		let second = viewDatetime.getSeconds(); second = ('0' + second).slice(-2);
		localStorage.setItem(
			`${urlRegion}/${_key}`,
			`${year}-${month}-${date} ${hour}:${minute}:${second}`
		);
	};
	if(map === 'detail') {
		let key = IBANEZ.va.pathname.split('/')[4];
		key = key.replace(/\.html/g, '');
		setRecentlyItemStorage(key);
	}
	// ＜共通＞ VIEWED アイテム取得
	const setRecentlyItem = () => {
		let recentStorage = [], recentStorageNew = [];
		let recentList = [];
		for(let i in localStorage) {
			if(i.indexOf(`${urlRegion}/`) !== -1) {
				recentStorage.push({
					idx: i,
					datetime: localStorage[i]
				});
			}
		}
		if(recentStorage.length) {
			recentStorage.sort((x, y) => {
				let xDate = x['datetime'];
				let yDate = y['datetime'];
				if(xDate > yDate) return (-1);
				if(xDate < yDate) return 1;
				return 0;
			});
			for(let i=0; i<recentStorage.length; i++) {
				if(i < 5) {
					recentStorageNew.push(recentStorage[i].idx);
				} else {
					localStorage.removeItem(recentStorage[i].idx);
				}
			}
		}
		if(recentStorageNew.length) {
			let p = new Promise((resolve) => {
				let count = 0;
				$.each(recentStorageNew, (idx, val) => {
					const re = new RegExp(`${urlRegion}/`);
					let key = val.replace(re, '');

					getJSONProdItem(key).then((data) => {
						if(data.rt_bn_product.length) {
							recentList.push({
								datetime: localStorage[val],
								img: data.rt_bn_product[0].cf_cm_region_thumb_img,
								alt: data.rt_bn_product[0].cf_cm_region_img_alt_1,
								code: data.rt_bn_product[0].cf_cm_product_code,
								key: data.rt_bn_product[0]._key
							});
							++count;
							if(count === recentStorageNew.length) {
								return resolve(recentList);
							}
						} else {
							return resolve(recentList);
						}
					});
				});
			});
			Promise.all([p]).then(() => {
				if(recentList.length) {
					recentList.sort((x, y) => {
						let xDate = x['datetime'];
						let yDate = y['datetime'];
						if(xDate > yDate) return (-1);
						if(xDate < yDate) return 1;
						return 0;
					});

					let recentHTML = '';
					for(let j=0; j<recentList.length; j++) {
						recentHTML +=
						'<li class="products-viewed-item">' +
						`<a href="/${urlRegion}/products/detail/${recentList[j].key}.html" class="mod-a">` +
						`<figure><img src="/common/product_artist_file/file/${recentList[j].img}?_size=1" ` +
						`alt="${recentList[j].alt}" class="width-u-100"></figure>` +
						`<p class="color_black ff_OpenSans">${recentList[j].code}</p></a></li>`;
					}
					$('.products-viewed-slide').append(recentHTML);
					$('.products-viewed-slide').slick({
						autoplay: true,
						slidesToShow: 5,
						slidesToScroll: 1,
						prevArrow: '<i class="icon icon-arrow_left mod-slide-arrow mod-slide-arrow_left"></i>',
						nextArrow: '<i class="icon icon-arrow_right mod-slide-arrow mod-slide-arrow_right"></i>',
						loop: true,
						infinite: true,
						responsive: [{
							breakpoint: 768,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
								centerMode: true,
								centerPadding: '20%'
							}
						}]
					});
				} else {
					$('.products-viewed').remove();
				}
			});
		} else {
			$('.products-viewed').remove();
		}
	};

	setRecentlyItem();

})(window.jQuery, window.IBANEZ, window.cssua);
